export const newsFeedReducer = (state, {type, payload}) => {
    switch (type) {
        case "initNewsFeed":
            return payload;
        case "addNewsFeed":
            console.log(state);
            console.log(payload);
            console.log([...state, ...payload]);
            return [...state, ...payload];
        default:
            return state;
    }
}
